import React from 'react'
import Link from 'jl-ui-kit/elements/link/Link'
import { PrimaryButton } from 'jl-ui-kit/elements/button/Button'
import auth0 from '../../utils/auth0'
import { getSignInUrl, getInitialScreen } from '../../utils/errors'
import styles from './LinkUsedError.scss'

type Props = {
  code: string
}

export default function LinkUsedError({ code }: Props): JSX.Element {
  const signInUrl = getSignInUrl()
  const handleClick = async () => {
    try {
      const initialScreen = getInitialScreen(code)
      await auth0().loginWithRedirect({
        initialScreen,
        redirect_uri: `${window.location.origin}/sso/browse/callback`,
      })
    } catch (error) {
      window.location.replace(signInUrl)
    }
  }

  return (
    <div className={styles.container} data-test="link-used-error">
      <p data-test="error-body">Please request another link.</p>

      <div>
        <PrimaryButton onClick={handleClick} className={styles.cta} data-test="error-cta">
          Request another link
        </PrimaryButton>
      </div>

      <div className={styles.signin}>
        <Link to={signInUrl} external data-test="signin-link">
          Back to sign in
        </Link>
      </div>
    </div>
  )
}
